import { parsePhoneNumber } from "libphonenumber-js";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { SpecialProjectDocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/SpecialProjectDocumentCategoryEnum";
import { IDocument } from "src/services/interfaces/IDocument";

export const getEmailRegex = (): RegExp => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validateEmail = (email: string): boolean => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhoneNumber = (value, region): boolean => {
  try {
    return parsePhoneNumber(value, region).isValid();
  } catch (e) {
    return false;
  }
};

export const generateQueryString = (obj: any): string => createQueryString(obj);

function createQueryString(obj: any, forceKey = null): string {
  let queryString = "";
  let flag = false;

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (value == null || (value.constructor.name === "Array" && value.length === 0)) {
        continue;
      }
      if (flag) {
        queryString += "&";
      }

      if (value && value.constructor.name === "Object") {
        queryString += createQueryString(value);
      } else if (value && value.constructor.name === "Array") {
        queryString += createQueryString(value, key);
      } else {
        queryString += `${forceKey ? forceKey : key}=${value}`;
      }

      flag = true;
    }
  }
  return queryString;
}

/**
 * Serializa lista de query string
 * @param list Lista de valores para ser serializada
 * @param indetifier indetificador (nome do parametro que o back espera)
 */
export const generateQueryStringList = (list, indetifier) => {
  if (list == null) {
    return "";
  }

  let query = "";
  list.forEach(element => {
    query += `${indetifier}=${element}&`;
  });

  return query.substring(0, query.length - 1);
};

export function Insert(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
}

export function validateForm(props) {
  let validated = true;
  if (props) {
    props.form.validateFields(err => {
      const erroList = err;
      if (erroList) {
        ShowNotification.Warn("Formulário inválido!", "Por favor, informe todos os campos obrigatórios.");
        validated = false;
      } else {
        validated = true;
      }
    });
  }
  return validated;
}

export function findDocumentByCategory(documents: IDocument[], category: DocumentCategoryEnum | SpecialProjectDocumentCategoryEnum): IDocument {
  if (documents) {
    const foundDocument = documents.find(doc => doc.category === category);
    return foundDocument ? foundDocument : null;
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/util/helper.ts